module.exports = __webpack_public_path__ + "static/media/Mag.ab065ee3.jpeg";